module.exports = __webpack_public_path__ + "static/media/cd.7b7fda57.png";